import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;

export const fetchTests = async (params) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.get(`${BASE_URL}tests`, {
      params: {
        user_id: params.user_id,
        testname: params.testname,
        testtype: params.testtype,
        subject: params.subject,
        topic: params.topic,
        year: params.year,
        month: params.month,
        page: params.page,
        page_size: params.page_size,
      },
      paramsSerializer: {
        serialize: (p) => {
          const searchParams = new URLSearchParams();
          Object.entries(p).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "") {
              return;
            }
            if (Array.isArray(value)) {
              value.forEach((item) => searchParams.append(key, item));
            } else {
              searchParams.append(key, value);
            }
          });
          return searchParams.toString();
        },
      },
      headers: {
        accept: "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
      signal: params.signal,
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

export const fetchTestExam = async (testId) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.get(`${BASE_URL}tests/${testId}/exam`, {
      headers: {
        accept: "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

// by sudz - 260926 - Start or resume IN_PROGRESS test
export const startTest = async (testId, userId) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.post(
      `${BASE_URL}tests/${testId}/start`,
      {},
      {
        params: { user_id: userId },
        headers: {
          accept: "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    sessionStorage.setItem("mcq_cache_invalidate", "true");
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

// by sudz - 260926 - Heartbeat to refresh updated_at and elapsed time
export const heartbeatTest = async (testId, userId, timeSpentSeconds) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.post(
      `${BASE_URL}tests/${testId}/heartbeat`,
      { time_spent_seconds: timeSpentSeconds },
      {
        params: { user_id: userId },
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    return response.data;
  } catch (error) {
    return null;
  }
};

// by sudz - 260926 - Cancel active in-progress test
export const cancelTest = async (testId, userId) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.post(
      `${BASE_URL}tests/${testId}/cancel`,
      {},
      {
        params: { user_id: userId },
        headers: {
          accept: "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    sessionStorage.setItem("mcq_cache_invalidate", "true");
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

export const submitTest = async (testId, userId, payload) => {  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.post(
      `${BASE_URL}tests/${testId}/submit`,
      payload,
      {
        params: {
          user_id: userId,
        },
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    sessionStorage.setItem("mcq_cache_invalidate", "true");
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

export const fetchTestReview = async (testId, userId) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.get(
      `${BASE_URL}tests/${testId}/review`,
      {
        params: {
          user_id: userId,
        },
        headers: {
          accept: "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

export const fetchTestScorecard = async (testId, userId) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.get(
      `${BASE_URL}tests/${testId}/scorecard`,
      {
        params: {
          user_id: userId,
        },
        headers: {
          accept: "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

export const reportTestQuestion = async (
  testId,
  questionId,
  reportType,
  description = "string"
) => {
  try {
    const token = localStorage.getItem("access_token");
    const userId = localStorage.getItem("user_id");

    const response = await axios.post(
      `${BASE_URL}tests/${testId}/questions/${questionId}/report`,
      {
        report_type: reportType,
        description,
      },
      {
        params: {
          user_id: userId,
        },
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};